const ChainData = {
    polygon: [{
        chainId: `${process.env.REACT_APP_CHAINID}`,
        rpcUrls: [`${process.env.REACT_APP_RPC}`],
        blockExplorerUrls: ["https://polygonscan.com"],
        chainName: "Polygon",
        nativeCurrency: {
            decimals: 18,
            name: 'MATIC',
            symbol: 'MATIC'
        }
    }],
}

const Assets = {
    polygon: {
        ERC20: [{
            name: "EXS",
            symbol: "EXS",
            // address: "0x11928CFCbC0398b9206C6D57ff7D8201555D6773",
            address: localStorage.getItem("currentNetwork") != undefined ? localStorage.getItem("currentNetwork") == "MUMBAI" ? `${process.env.REACT_APP_MUMBAI_ER20}` : localStorage.getItem("currentNetwork") == "EHETERUM" ? `${process.env.REACT_APP_RINKEY_ER20}` : `${process.env.REACT_APP_BINANCE_ER20}` : `${process.env.REACT_APP_MUMBAI_ER20}`,
            decimals: 18,
            icon: "https://img.ex-sports.io/imgs/icons/exs.png",
        },
        {
            name: localStorage.getItem("currentNetwork") != undefined ? localStorage.getItem("currentNetwork") == "MUMBAI" ? 'USDT' : localStorage.getItem("currentNetwork") == "EHETERUM" ? 'USDT' : 'USDT' : 'USDT',
            symbol: "USDT",
            // name: "USDT",
            address: localStorage.getItem("currentNetwork") != undefined ? localStorage.getItem("currentNetwork") == "MUMBAI" ? `${process.env.REACT_APP_USDT_POLY}` : localStorage.getItem("currentNetwork") == "EHETERUM" ? `${process.env.REACT_APP_USDT_ETH}` : `${process.env.REACT_APP_USDT_BNB}` : `${process.env.REACT_APP_USDT_POLY}`,
            // address: "0xc2132d05d31c914a87c6611c10748aeb04b58e8f",
            decimals: localStorage.getItem("currentNetwork") != undefined ? localStorage.getItem("currentNetwork") == "MUMBAI" ? 6 : localStorage.getItem("currentNetwork") == "EHETERUM" ? 6 : 18 : 6,
            icon: `${process.env.REACT_APP_IMAGE_URL}/assets/images/icons/tether.svg`

        },

        ],
        ERC1155: [{
            name: "Ex-Sports",
            symbol: "ExSports",
            address: localStorage.getItem("currentNetwork") != undefined ? localStorage.getItem("currentNetwork") == "MUMBAI" ? `${process.env.REACT_APP_MUMBAI_ER1155}` : localStorage.getItem("currentNetwork") == "EHETERUM" ? `${process.env.REACT_APP_RINKEY_ER1155}` : `${process.env.REACT_APP_BINANCE_ER1155}` : `${process.env.REACT_APP_MUMBAI_ER1155}`,
            // address: "0x46b5F1731C0E5a0Ac408fE57a385E62a7bED9f2A",
            icon: "url"
        }],
        ONION: [{
            name: "Onion Auctions",
            address: localStorage.getItem("currentNetwork") != undefined ? localStorage.getItem("currentNetwork") == "MUMBAI" ? `${process.env.REACT_APP_MUMBAI_ONION}` : localStorage.getItem("currentNetwork") == "EHETERUM" ? `${process.env.REACT_APP_RINKEY_ONION}` : `${process.env.REACT_APP_BINANCE_ONION}` : `${process.env.REACT_APP_MUMBAI_ONION}`,
            // address: "0xf04834284bD0e9cE4a892c0bF825Ed06F010ec9D",
            symbol: "OAS",
            decimals: 1,
            icon: "url"
        }],
        explorer: "https://polygonscan.com",
        sockets: [`${process.env.REACT_APP_WSS}`]
        // sockets: ["wss://sad-neumann:quench-strobe-sash-cortex-uphill-decade@ws-nd-584-382-582.p2pify.com"]

    }
}

export { ChainData, Assets }